import { CalendlyLogResponse } from './useMemberCalendlyCall.interface';

import collectiveApi from 'modules/common/collectiveApi';

export default async function fetchMemberCalendlyLogs(): Promise<CalendlyLogResponse[]> {
    const { data } = await collectiveApi.get<CalendlyLogResponse[]>('member-calendly-log/');
    return data;
}
